
// Redemption Methods
export const GET_ALL_REDEMPTION_METHOD_REQUEST = "GET_ALL_REDEMPTION_METHOD_REQUEST"
export const GET_ALL_REDEMPTION_METHOD_SUCCESS = "GET_ALL_REDEMPTION_METHOD_SUCCESS"
export const GET_ALL_REDEMPTION_METHOD_FAILURE = "GET_ALL_REDEMPTION_METHOD_FAILURE"